import {useEffect} from 'react';
import {isBrowserContext} from 'core/helpers';

// делаем один глобальный слушатель ресайзинга
let isListening = false;
const subscribers = new Set<(event: UIEvent) => void>();

const handleWindowResize = (event: UIEvent) => {
    Array.from(subscribers).forEach((callback) => callback(event));
};

const addSubscriber = (callback: (event: UIEvent) => void) => {
    subscribers.add(callback);

    if (!isListening && isBrowserContext()) {
        window.addEventListener('resize', handleWindowResize);
        isListening = true;
    }
};

const removeSubscriber = (callback: (event: UIEvent) => void) => {
    subscribers.delete(callback);

    if (isListening && 0 === subscribers.size && isBrowserContext()) {
        window.removeEventListener('resize', handleWindowResize);
        isListening = false;
    }
};

export const useResize = (callback: (event: UIEvent) => void) => {
    useEffect(() => {
        if (!callback || !isBrowserContext()) {
            return;
        }

        addSubscriber(callback);
        // eslint-disable-next-line consistent-return
        return () => removeSubscriber(callback);
    }, [callback]);
};
